import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useState } from 'react';
import EffectiveDateField from '../common/EffectiveDateField';
import CurrencyField from '../../benefit/fields/CurrencyField';
import { useUI } from '../../../context/UIContext';
import { FormValidationContext } from '../../benefit/common/FormValidationContext';
import { useHydratedForm } from '../hooks/useHydratedForm';
import { useBootstrapValidation } from '../hooks/userBootstrapValidation';
import { calculatorService } from '../../../services/calculatorService';
import { hasMeaningfulChange } from '../../../utils/hasMeaningfulChange';

const mapAmiAdderToForm = (amiAdder) => ({
  id: amiAdder.id,
  county: amiAdder.county,
  amiAdderPerHousehold: amiAdder.amiAdderPerHousehold ?? '',
  effectiveDate: amiAdder.effectiveDate ?? '',
});

const MEANINGFUL_FIELDS = ['amiAdderPerHousehold', 'effectiveDate'];

const EditAmiAdderModal = ({ amiAdder, onSave, onClose }) => {
  const [form, setForm] = useHydratedForm(amiAdder, mapAmiAdderToForm);

  const { validated, validateForm } = useBootstrapValidation();
  const [customError, setCustomError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState('');
  const { showLoading, hideLoading, showError, showSuccess } = useUI();

  if (!amiAdder) return null;

  const handleSubmit = async (e) => {
    const formEl = e.currentTarget;
    e.preventDefault();

    if (!hasMeaningfulChange(amiAdder, form, MEANINGFUL_FIELDS)) {
      setCustomError(
        'At least one value must be changed before saving.'
      );
      return;
    }

    if (!validateForm(formEl)) return;
    setIsSubmitting(true);
    showLoading('Saving AMI Adder…');
    try {
      const res = await calculatorService.saveAmiAdder(form);
      setIsSubmitting(false);
      if (res.success) {
        onSave(res.data);
        onClose();
        showSuccess(`AMI Adder configuration for ${amiAdder.county} saved.`);
      } else {
        showError(res.error);
      }
    } finally {
      setIsSubmitting(false);
      hideLoading();
    }
  };

  return (
    <Modal show onHide={onClose} size="lg" centered>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <FormValidationContext.Provider value={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              Edit AMI Household Adder — {form.county}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row className="mb-3">
              <Col md={6}>
                <CurrencyField
                  value={form.amiAdderPerHousehold}
                  scale={0}
                  fieldName="AMI Adder (per additional household)"
                  required
                    onChange={(value) =>
                      setForm({ ...form, amiAdderPerHousehold: value })
                    }
                  isSubmitting={isSubmitting}
                />
              </Col>

              <Col md={6}>
                <EffectiveDateField
                  value={form.effectiveDate}
                  onChange={(v) => setForm({ ...form, effectiveDate: v })}
                  isSubmitting={isSubmitting}
                />
              </Col>
            </Row>

            {customError && (
              <div className="text-danger mt-2">
                {customError}
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </Modal.Footer>

        </FormValidationContext.Provider>
      </Form>
    </Modal>
  );
};

export default EditAmiAdderModal;